export const htmlContent = /<\b(?:[^i].*?>|i[^m].*?>|im[^g].*?>|img\B.*?>)/g;

const extractTextFromHtml = content => {
  const tempNode = document.createElement('div');
  tempNode.innerHTML = content.replace(htmlContent, '\n');


  /*
    There is a possibility that the incoming content contains html encoded (instead of html markup)
    tempNode help us guarantee that if that is the case the result (textContent/innerText)
    will be transformed into html markup.
    By adding a second "cleanNode" we make sure that the extracted text will be just text.
  */

  const cleanNode = document.createElement('div');
  cleanNode.innerHTML = tempNode.textContent || tempNode.innerText || '';

  let cleanText = cleanNode.textContent || cleanNode.innerText || '';

  /*
    Replace extra newlines (with two newlines \n\n) if there are 3 or more continuous.
  */
  const removeExtraNewlines = /(\n{3,})/g;
  cleanText = cleanText.replace(removeExtraNewlines, '\n\n');
  return cleanText;
};

export default extractTextFromHtml;
